export const Colors = {
  primary: "#1A76E3",
  white: "#eee",
  black: "#131313",
};
